import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  CanActivate,
  Router,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AuthService } from "./auth.service";
@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, public authService: AuthService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.currentUser.pipe(
      map((user) => {
        if (user) {
          return true;
        } else {
          // this.router.navigate(["/login"], {});
          window.location.href = "https://sinnara-app.com/log-in.html";
        }
      }),
      catchError((err) => {
        // this.router.navigate(["/login"]);
        window.location.href = "https://sinnara-app.com/log-in.html";
        return of(false);
      })
    );
  }

  isLoggedIn() {
    this.authService.currentUser.subscribe((user) => {
      if (user) {
        return true;
      }
    });
    return false;
  }
}
